import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Alpine.js (replaces the unpkg CDN <script> tags). The Collapse plugin must be
// registered before Alpine.start(), which mirrors the old "load collapse first"
// CDN ordering.
import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"

Alpine.plugin(collapse)
window.Alpine = Alpine
Alpine.start()
